export default "__VITE_ASSET__DmdDcihh__"